import techCrunchLogo from './svg/new/TechCrunch.svg'
import forbesLogo from './svg/new/forbes.svg'
import nyTimesLogo from './svg/new/nyt.svg'
import wpLogo from './svg/new/wp.svg'
import wsjLogo from './svg/new/wsj.svg'

export const PRESS_OUTLETS = [
  { label: 'New York Times', img: nyTimesLogo },
  { label: 'Forbes', img: forbesLogo },
  { label: 'TechCrunch', img: techCrunchLogo },
  { label: 'Wall Street Journal', img: wsjLogo },
  { label: 'Washington Post', img: wpLogo },
] as const
